export default {
  // Chờ trong database
  None: 0,

  // Đã lấy khỏi database và đang chờ trong memory
  DequeuInMemory: 1,

  // Đang xử lý
  Converting: 2,

  // Thành công
  Success: 3,

  // Lỗi
  Error: 4,

  // Dữ liệu lỗi khi chuyển đổi
  ConvertError: 7,
};
